import { createContext, FC, useContext } from "react"
import { PathLeaf, PathTree } from "./FileTemplateDetail.JsonMappingViewer";

export const hehe = ""

interface JsonMappingViewerPresetProps {
  editor?: {
    isNotApplicable: (pnode: PathLeaf|PathTree) => boolean|null;
  }
}

const JsonMappingViewerPresetContext = createContext({} as any)


export const JsonMappingViewerPresetProvider : FC<{preset: JsonMappingViewerPresetProps}> = ({
  preset, children
}) => {
  return (
    <JsonMappingViewerPresetContext.Provider value={preset}>
      {children}
    </JsonMappingViewerPresetContext.Provider>
  )
}


export const useJsonMappingViewerPresetContext = (): JsonMappingViewerPresetProps => useContext<JsonMappingViewerPresetProps>(JsonMappingViewerPresetContext)

export const MongoDBJmvPreset : JsonMappingViewerPresetProps = {
  editor: {
    isNotApplicable: (pnode: PathLeaf|PathTree) => {
      if (pnode.kind === 'leaf') {
        const leaf = pnode
        return ((leaf.jpath ?? '').endsWith('._id')) ? true : null
      } else {
        const tree = pnode
        return tree.parts[0] === '_id' ? true : null
      }
    }
  }
}

export const EmptyPreset : JsonMappingViewerPresetProps = {} as any
